import useAssetCache from '../hooks/assets';

// model copied from "https://jotai.org/docs/guides/async"
export default function PreloadAssets() {
  useAssetCache()
  return null
}